export default function sortByStartDates(items) {
  items.sort((a, b) => a.startDate - b.startDate);
}
